import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  bnText: "",
  enText: "",
  entity: "",
  chatReply: "",
  chatReplyEn: "",
  cost: "",
  result: JSON,
  session: ""
}


export const translateSlice = createSlice({
  name: 'asr',
  initialState,
  reducers: {
    setBnText: (state, action) => {
      state.bnText = action.payload
    },
    setEnText: (state, action) => {
      state.enText = action.payload
    },
    setResult: (state, action) => {
      state.result = action.payload
    },
    setEntity: (state, action) => {
      state.entity = action.payload
    },
    setSession: (state, action)=> {
      state.session = action.payload
    },
    setChatReply: (state, action)=> {
      state.chatReply = action.payload
    },
    setChatReplyEn: (state, action)=> {
      state.chatReplyEn = action.payload
    },
    setCost: (state, action)=> {
      state.cost = action.payload
    },
    resetSession: (state) => {
      state.session = "";
    },
  },
})

// Action creators are generated for each case reducer function
export const { setEnText, setBnText, setEntity, setResult, setSession, resetSession, setChatReply, setChatReplyEn, setCost } = translateSlice.actions

export default translateSlice.reducer